// extracted by mini-css-extract-plugin
export default {"Avatar":"FlioSync_Avatar__zvbTo","Upper":"FlioSync_Upper__UFoDr"};